export default "__VITE_ASSET__B2PuEHXn__"